<template>
  <div class="bnp-file-list">
    <loading v-if="loadingRender || signingInProgress"></loading>

    <div v-if="ShowEmpty && !loadingRender" class="bnp-file-empty">
      <i class="fas fa-folder-open bnp-file-empty__icon" aria-hidden="true"></i>
      <p class="bnp-file-empty__title">فایلی برای نمایش موجود نیست</p>
      <p class="bnp-file-empty__desc">
        در حال حاضر فرم یا فایلی روی سرور ثبت نشده است.
      </p>
    </div>

    <template v-else-if="!loadingRender">
      <p class="bnp-file-list__count">{{ filesCountLabel }}</p>

      <div class="bnp-file-grid">
        <article
          v-for="(item, index) in Files"
          :key="item.id || index"
          class="bnp-file-card"
        >
          <div class="bnp-file-card__head">
            <div
              class="bnp-file-card__visual"
              :class="'is-' + fileKind(item.filename)"
              :title="fileTypeLabel(item.filename)"
            >
              <i :class="fileIcon(item.filename)" aria-hidden="true"></i>
            </div>

            <div class="bnp-file-card__main">
              <p class="bnp-file-card__name" dir="auto" :title="item.filename">
                <bdi>{{ item.filename }}</bdi>
              </p>
              <div class="bnp-file-card__meta">
                <span class="bnp-file-card__category">{{
                  fileCategory(item)
                }}</span>
                <span class="bnp-file-card__ext" dir="ltr">{{
                  fileExtension(item.filename)
                }}</span>
              </div>
            </div>
          </div>

          <div class="bnp-file-card__actions">
            <a
              :download="item.filename"
              :href="'data:application/octet-stream;base64,' + item.binary"
              class="bnp-button-primary"
            >
              <i class="fas fa-download" aria-hidden="true"></i>
              دریافت فایل
            </a>

            <button
              v-if="canSign(item)"
              type="button"
              :disabled="signingInProgress"
              :aria-busy="signingFileId === item.id ? 'true' : 'false'"
              @click="GetfileEmza(item)"
              class="bnp-button-secondary"
            >
              <span
                v-if="signingFileId === item.id"
                class="bnp-spinner"
                aria-hidden="true"
              ></span>
              <i v-else class="fas fa-signature" aria-hidden="true"></i>
              {{ signingFileId === item.id ? "در حال امضا..." : "امضا" }}
            </button>

            <button
              v-if="$session.get('IsRahbar')"
              type="button"
              class="bnp-button-icon"
              aria-label="حذف فایل"
              title="حذف فایل"
              @click="Delete(item.id)"
            >
              <i class="fas fa-trash" aria-hidden="true"></i>
            </button>
          </div>
        </article>
      </div>
    </template>
  </div>
</template>
<script>
import loading from "../../Tools/NetPa/Loading.vue";

export default {
  props: ["IsAdmin"],
  components: {
    loading,
  },
  data() {
    return {
      Tablekey: 0,
      ShowEmpty: false,
      Files: [],
      IsEmza: false,
      loadingRender: false,
      signingInProgress: false,
      signingFileId: null,
    };
  },
  computed: {
    filesCountLabel() {
      const count = (this.Files || []).length.toLocaleString("fa-IR");
      return count + " فایل آماده دریافت";
    },
  },
  methods: {
    GetFile() {
      this.ShowEmpty = false;
      this.loadingRender = true;

      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        Token: this.$session.get("TokenNetPa"), // NetPa HANDOFF P1-4
        ArryfildValue: {
          MasterId: this.$session.get("CustCode"),
          tableName: "ExtraForms",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        this.loadingRender = false;

        this.file = result.data;
        this.Tablekey++;
        if (result.data == null || result.data.length == 0) {
          this.ShowEmpty = true;
        } else {
          this.Files = result.data;
        }
      });
    },
    showEmzaError() {
      this.$mySweetDefaultTost(
        "عملیات ناموفق",
        "خطایی رخ داد. لطفا در ساعات آینده مجددا تلاش کنید",
        "error",
        5000,
      );
    },
    async downloadSignedPdf(base64Data, contentType, fileName) {
      const type = contentType || "application/octet-stream";
      const cleanBase64 = String(base64Data).replace(/\s/g, "");
      let blob;

      if (typeof Uint8Array.fromBase64 === "function") {
        blob = new Blob([Uint8Array.fromBase64(cleanBase64)], { type });
      } else {
        const response = await fetch(`data:${type};base64,${cleanBase64}`);
        blob = await response.blob();
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "downloaded-file";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    GetfileEmza(item) {
      if (this.signingInProgress) return;

      const userInfo = this.$session.get("UserInfoNetPa");
      if (
        !item ||
        !item.id ||
        !userInfo ||
        !userInfo.codeMeli ||
        !userInfo.mobile
      ) {
        this.showEmzaError();
        return;
      }

      this.signingInProgress = true;
      this.signingFileId = item.id;
      this.$PostData({
        Method: "POST",
        Action: "Uploader/GetfileEmza",
        ArryfildValue: {
          FileId: item.id,
          CustCode: this.$session.get("CustCode"),
          CodeMeli: userInfo.codeMeli,
          Mobile: userInfo.mobile,
        },
      })
        .then((result) => {
          if (!result) {
            this.showEmzaError();
            return;
          }

          if (result.status == "linkCreated") {
            const payload = result.data || result.Data;
            const gatewayLink =
              payload && (payload.gatewayLink || payload.GatewayLink);
            if (!gatewayLink) {
              this.showEmzaError();
              return;
            }
            window.location.href = gatewayLink;
            return;
          }

          if (result.status == "downLoadFile") {
            const base64Data = result.data || result.Data;
            if (!base64Data) {
              this.showEmzaError();
              return;
            }
            return this.downloadSignedPdf(
              base64Data,
              result.type || result.Type,
              item.filename,
            );
          }

          this.showEmzaError();
        })
        .catch(() => {
          this.showEmzaError();
        })
        .finally(() => {
          this.signingInProgress = false;
          this.signingFileId = null;
        });
    },
    Delete(id) {
      this.$SweetQustion(
        "درخواست حذف فایل",
        "از حذف فایل انتخابی خود اطمینان دارید ؟",
        "warning",
        "حــذف",
        "انصراف",
        id,
        this.ConfirmDelete,
        this.Cancel,
      );
    },
    ConfirmDelete(id) {
      var axios = {
        Method: "POST",
        Action: "Uploader/Delete",
        Token: this.$session.get("TokenNetPa"), // NetPa HANDOFF P1-4
        ArryfildValue: { Id: id },
      };
      this.$PostData(axios).then((result) => {
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.GetFile();
      });
    },
    Cancel() {},
    canSign(item) {
      const grp = item.wwwtblcomboidgrp328;
      return grp == 100 || grp == 101 || grp == 102;
    },
    fileCategory(item) {
      const map = {
        100: "قرارداد عضویت",
        101: "قرارداد وام",
        102: "قرارداد (امضا)",
        181070513: "فرم جانبی",
      };
      return map[item.wwwtblcomboidgrp328] || "فایل";
    },
    fileExtension(name) {
      if (!name || name.indexOf(".") === -1) return "FILE";
      return name.split(".").pop().toUpperCase();
    },
    fileTypeLabel(name) {
      const ex = (name || "").split(".").pop().toLowerCase();
      if (["rar", "zip"].includes(ex)) return "فایل فشرده";
      if (ex === "pdf") return "پی‌دی‌اف";
      if (["png", "jpg", "jpeg"].includes(ex)) return "تصویر";
      return "فایل";
    },
    fileKind(name) {
      const ex = (name || "").split(".").pop().toLowerCase();
      if (["rar", "zip"].includes(ex)) return "zip";
      if (["png", "jpg", "jpeg"].includes(ex)) return "img";
      if (ex === "pdf") return "pdf";
      return "file";
    },
    fileIcon(name) {
      return {
        zip: "fas fa-file-archive",
        img: "fas fa-file-image",
        pdf: "fas fa-file-pdf",
        file: "fas fa-file-alt",
      }[this.fileKind(name)];
    },
  },
  created() {
    this.GetFile();
  },
};
</script>
<style scoped>
.bnp-file-list {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-radius-md: 14px;
  --bnp-radius-lg: 20px;
  --bnp-radius-pill: 999px;
  --bnp-shadow-sm: 0 5px 18px rgba(31, 42, 79, 0.08);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);

  width: 100%;
  min-width: 0;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  color: var(--bnp-text-primary);
}

.bnp-file-list__count {
  margin: 0 0 16px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.6;
}

.bnp-file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr));
  gap: 16px;
}

.bnp-file-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-lg);
  background: #fff;
  box-shadow: var(--bnp-shadow-sm);
  transition:
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.bnp-file-card:hover {
  border-color: var(--bnp-border-hover);
  box-shadow: var(--bnp-shadow-md);
  transform: translateY(-2px);
}

.bnp-file-card__head {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.bnp-file-card__visual {
  display: grid;
  place-items: center;
  flex: 0 0 52px;
  width: 52px;
  height: 52px;
  font-size: 24px;
  border-radius: 14px;
}

.bnp-file-card__visual.is-pdf {
  color: #c0392b;
  background: #fdecea;
}

.bnp-file-card__visual.is-zip {
  color: #b7791f;
  background: #fdf5e6;
}

.bnp-file-card__visual.is-img {
  color: #2b8a6e;
  background: #e8f6f1;
}

.bnp-file-card__visual.is-file {
  color: var(--bnp-brand-navy);
  background: var(--bnp-surface-accent);
}

.bnp-file-card__main {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
}

.bnp-file-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.bnp-file-card__category {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  color: var(--bnp-brand-navy);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  background: var(--bnp-surface-accent);
  border-radius: var(--bnp-radius-pill);
}

.bnp-file-card__ext {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  color: var(--bnp-text-secondary);
  font-size: 10px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.04em;
  background: var(--bnp-surface-subtle);
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-pill);
}

.bnp-file-card__name {
  margin: 0;
  overflow: hidden;
  color: var(--bnp-text-primary);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bnp-file-card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-file-card__actions .bnp-button-icon {
  margin-inline-start: auto;
}

.bnp-button-primary,
.bnp-button-secondary,
.bnp-button-icon {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  min-height: 40px;
  padding: 0 16px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  border-radius: 14px;
  cursor: pointer;
  transition:
    background var(--bnp-motion-fast) ease,
    border-color var(--bnp-motion-fast) ease,
    color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    transform var(--bnp-motion-fast) ease;
}

.bnp-button-primary i,
.bnp-button-secondary i,
.bnp-button-icon i {
  font-size: 13px;
  line-height: 1;
}

.bnp-button-primary {
  color: var(--bnp-brand-navy) !important;
  border: 1px solid #d9dcec;
  background: #f1f2f9;
  box-shadow: none;
}

a.bnp-button-primary:hover,
.bnp-button-primary:hover {
  color: #fff !important;
  border-color: transparent;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  text-decoration: none;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(41, 52, 95, 0.14);
}

.bnp-button-secondary {
  color: var(--bnp-brand-navy);
  background: #fff;
  border: 1px solid #c9d5df;
  box-shadow: none;
}

.bnp-button-secondary:hover:not(:disabled) {
  color: var(--bnp-brand-navy);
  background: var(--bnp-surface-accent);
  border-color: #9eb0c0;
}

.bnp-button-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bnp-button-icon {
  flex: 0 0 40px;
  width: 40px;
  padding: 0;
  color: #d07a74;
  background: #fff6f5;
  border: 1px solid #f0d5d2;
  box-shadow: none;
}

.bnp-button-icon:hover {
  color: #c2655e;
  background: #fcefed;
  border-color: #e8c2be;
}

.bnp-button-primary:focus-visible,
.bnp-button-secondary:focus-visible,
.bnp-button-icon:focus-visible {
  outline: none;
  box-shadow: var(--bnp-focus-ring);
}

.bnp-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(41, 52, 95, 0.22);
  border-top-color: var(--bnp-brand-navy);
  border-radius: 50%;
  animation: bnp-spin 0.7s linear infinite;
}

.bnp-file-empty {
  padding: 40px 16px;
  text-align: center;
  border: 1px dashed var(--bnp-border-default);
  border-radius: var(--bnp-radius-lg);
  background: var(--bnp-surface-subtle);
}

.bnp-file-empty__icon {
  margin-bottom: 12px;
  color: var(--bnp-text-secondary);
  font-size: 28px;
}

.bnp-file-empty__title {
  margin: 0 0 6px;
  color: var(--bnp-text-primary);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.7;
}

.bnp-file-empty__desc {
  margin: 0;
  color: var(--bnp-text-secondary);
  font-size: 14px;
  line-height: 1.9;
}

@media (max-width: 480px) {
  .bnp-file-card__visual {
    flex-basis: 44px;
    width: 44px;
    height: 44px;
    font-size: 20px;
  }

  .bnp-file-card__actions .bnp-button-primary {
    flex: 1 1 auto;
  }
}

@keyframes bnp-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-file-list *,
  .bnp-file-list *::before,
  .bnp-file-list *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }

  .bnp-file-card:hover,
  .bnp-button-primary:hover {
    transform: none;
  }
}
</style>
